import { useRef, useState, useEffect } from "react";
import clsx from "clsx";
import { FaAngleDown, FaAngleUp, FaCheck } from "react-icons/fa";

import { Text } from "components/common";
import useOnClickOutside from "hooks";
import classes from "./CurrencyDropdown.module.css";

const CurrencyDropdown = ({
  isActive,
  items,
  selectedValue,
  onSelect,
  setIsActive,
}) => {
  const ref = useRef(null);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useOnClickOutside(ref, () => setIsActive(false));

  return (
    <div className={classes.dropdown} ref={ref}>
      <div
        className={clsx(classes.labelContainer)}
        onClick={() => setIsActive((prev) => !prev)}
      >
        <Text primitive100>{selectedValue.toUpperCase()}</Text>
        {isActive ? (
          <FaAngleUp className={classes.arrow} />
        ) : (
          <FaAngleDown className={classes.arrow} />
        )}
      </div>

      <div
        ref={dropdownRef}
        className={clsx(classes.dropdownMain, isActive && classes.active)}
        role="listbox"
        aria-expanded={isActive}
      >
        <div className={clsx(classes.list, "overflow")}>
          {items?.map((item, idx) => (
            <div
              key={`item-${idx}`}
              className={clsx(
                classes.listItem,
                selectedValue === item && classes.active
              )}
              onClick={(e) => {
                setIsActive(false);

                onSelect(item.id);
              }}
            >
              <Text medium>{item.name}</Text>
              {selectedValue === item && (
                <FaCheck className={classes.checkIcon} />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CurrencyDropdown;
